import { Controller } from "@hotwired/stimulus"

// Google Calendar's keys on the Calendar page: t today, n / j next and p / k
// previous period, a / w / m / y for agenda (the list), week, month and year.
// They press the same links the toolbar shows, so Turbo navigates exactly as
// for a click. Ignored while typing, and with a modifier held.
const MOVES = { t: "today", n: "next", j: "next", p: "prev", k: "prev" }
const VIEWS = { a: "list", w: "week", m: "month", y: "year" }

export default class extends Controller {
    connect() {
        this.onKey = (event) => this.handle(event)
        document.addEventListener("keydown", this.onKey)
    }

    disconnect() {
        document.removeEventListener("keydown", this.onKey)
    }

    handle(event) {
        if (event.metaKey || event.ctrlKey || event.altKey || event.defaultPrevented) return
        let target = event.target
        if (target.closest?.("input, textarea, select, [contenteditable='true'], dialog[open]")) return

        let key = event.key.toLowerCase()
        let link = null
        if (MOVES[key]) link = document.querySelector(`[data-cal-nav="${MOVES[key]}"]`)
        else if (VIEWS[key]) link = document.querySelector(`[data-cal-view="${VIEWS[key]}"]`)
        if (!link) return

        event.preventDefault()
        link.click()
    }
}
